import Flex from "@ui-kit/layout/Flex/Flex.web";
import type { SeatingLayoutSharedProps } from "./SeatingLayout.props";
import SeatingMainWrapper from "./SeatingMainWrapper/SeatingMainWrapper.web";
import SeatingSideWrapper from "./SeatingSideWrapper/SeatingSideWrapper.web";

export default function SeatingLayout({
  mapElements,
  sidebarElements,
  useFullScreen = false,
  maxMapHeight,
}: SeatingLayoutProps): JSX.Element {
  return (
    <Flex flex="1" minHeight="0" maxHeight={maxMapHeight}>
      <SeatingMainWrapper
        direction="column"
        boxSizing="border-box"
        position="relative"
        backgroundColor="gray.100"
        flexGrow={1}
        overflow="hidden"
        useFullScreen={useFullScreen}
      >
        {mapElements}
      </SeatingMainWrapper>
      <SeatingSideWrapper
        direction="column"
        borderLeft="1px solid"
        borderColor="gray.400"
        justifyContent="space-between"
        zIndex="seatingMap"
        backgroundColor="bg"
      >
        {sidebarElements}
      </SeatingSideWrapper>
    </Flex>
  );
}

export type SeatingLayoutProps = SeatingLayoutSharedProps & {
  // Add any web specific props here.
};
